import { render, staticRenderFns } from "./GeneralDocuments.vue?vue&type=template&id=6fc1377a&"
import script from "./GeneralDocuments.vue?vue&type=script&lang=js&"
export * from "./GeneralDocuments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports